<template>
    <div>
        <div class="row mb-5">
            <div class="col-md-12">
                <stats-infos :user="selectedUser" :dates="datesForStatsInfos"></stats-infos>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <stats-calendar :user="selectedUser"  @date-change="calendarDateChanged"></stats-calendar>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../../Includes/PageHeader";
import StatsCalendar from "../../../LockerRoom/SubPages/Includes/StatsCalendar";
import StatsInfos from "../../../LockerRoom/SubPages/Includes/StatsInfos";

export default {
    name: "UserAform",
    components: {StatsInfos, StatsCalendar, PageHeader },
    data: () => ({
        chartMode: "daily",
        userStats: [],

        datesForStatsInfos: null,
    }),
    mounted() {
    },
    methods: {
        calendarDateChanged(dates) {
            this.datesForStatsInfos = dates;
        },
    },
    computed: {
        selectedUser() {
            return parseInt(this.$route.params.user);
        }
    }
};
</script>

<style scoped></style>
